













































import { Component, Prop, PropSync, Vue, Emit } from 'vue-property-decorator';

@Component
export default class ShiftHeader extends Vue {
  private typeToLabel: { [key: string]: string } = {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    '4day': '4 Days',
    gant: 'Gant',
  };
  @PropSync('typeValue', { type: String, required: true })
  public type!: string;

  @Prop({ type: Function, required: true })
  public prev!: () => void;

  @Prop({ type: Function, required: true })
  public next!: () => void;

  @Prop({ type: Function, required: true })
  public setToday!: () => void;

  @Prop({ type: String, required: true })
  public title!: string;

  @Emit('open-batch-submission-modal')
  private openBatchSubmissionModal() {}
}
